import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSearchParams } from '~/hooks/search/useSearchParams';
import { setSearchSortOverrideAction } from '~/store/configViews/actions';
import { searchSortOverrideSelector } from '~/store/configViews/selectors';

export const useClearSearchSortOverrideWhenQueryCleared = () => {
  const dispatch = useDispatch();
  const { hasSearchParams } = useSearchParams();
  const searchSortOverride = useSelector(searchSortOverrideSelector);

  useEffect(() => {
    if (!hasSearchParams && searchSortOverride) {
      dispatch(setSearchSortOverrideAction({ searchSortOverride: null }));
    }
  }, [dispatch, hasSearchParams, searchSortOverride]);
};
